import imageCompression from "browser-image-compression";

const COMPRESSION_OPTIONS = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1600,
  useWebWorker: true,
};

/**
 * Compresses an image file for upload. Non-image files (PDFs, etc.) are
 * returned unchanged since they cannot be processed via the canvas-based
 * compression pipeline.
 */
export const compressImageFile = async (file: File): Promise<File> => {
  if (!file.type.startsWith("image/")) {
    return file;
  }

  return imageCompression(file, COMPRESSION_OPTIONS);
};
